import axios from 'axios';
import qs from 'qs';

export class ApiService {
  private server: string;
  private access_token: string | undefined;
  private api: Axios.AxiosInstance;

  constructor(server: string, access_token: string | undefined) {
    console.log(server);
    this.server = server;
    this.access_token = access_token;
    this.api = this.instantiateApi();
  }

  private getHeadersDefault(access_token: string | undefined): Record<string, string> {
    const headersDefault: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    if (access_token) {
      headersDefault['Authorization'] = `Bearer ${access_token}`;
    }

    return headersDefault;
  }

  private instantiateApi(): Axios.AxiosInstance {
    const api = axios.create({
      baseURL: this.server,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers: this.getHeadersDefault(this.access_token),
    });

    return api;
  }

  async get<T = unknown>(url: string, parameters?: Record<string, unknown>): Promise<T | null> {
    const response = await this.api.get<T>(url, {
      params: parameters,
    });
    return response.data;
  }

  async post<T = unknown>(url: string, body: unknown): Promise<T> {
    const response = await this.api.post<T>(url, body);
    return response.data;
  }

  async put<T = unknown>(url: string, body: unknown): Promise<T> {
    const response = await this.api.put<T>(url, body);
    return response.data;
  }

  async patch<T = unknown>(url: string, body: T): Promise<T> {
    const response = await this.api.patch<T>(url, body);
    return response.data;
  }

  async delete<T = unknown>(url: string, parameters?: Record<string, unknown>): Promise<T> {
    const response = await this.api.delete<T>(url, {
      params: parameters,
    });
    return response.data;
  }
}
